module.exports = __webpack_public_path__ + "static/img/btm.f6a24ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loginImg/btm.png
// module id = dBr4
// module chunks = 18